import DataRoomProgression from './DataRoomProgression.component';

export default DataRoomProgression;